<div #container [ngClass]="'toast-wrapper p-toast p-component p-toast-' + position" [ngStyle]="style" [class]="styleClass">
  <p-toastItem
    *ngFor="let msg of messages; let i = index"
    [message]="msg"
    [index]="i"
    (onClose)="onMessageClose($event)"
    [template]="template"
    @toastAnimation
    (@toastAnimation.start)="onAnimationStart($event)"
    (@toastAnimation.done)="onAnimationEnd($event)"
    [showTransformOptions]="showTransformOptions"
    [hideTransformOptions]="hideTransformOptions"
    [showTransitionOptions]="showTransitionOptions"
    [hideTransitionOptions]="hideTransitionOptions"
  ></p-toastItem>
</div>

